import axios from "axios";

const cancelTokenSource = axios.CancelToken.source();
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
  cancelToken: cancelTokenSource.token,
  paramsSerializer: (params) => {
    return Object.keys(params)
      .flatMap((key) => {
        const value = params[key];
        if (Array.isArray(value)) {
          return value.map((v: string) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
        }
        if (value === undefined || value === null || value === "") return [];
        return [`${encodeURIComponent(key)}=${encodeURIComponent(value)}`];
      })
      .join("&");
  },
});

export default axiosInstance;
